import { gql } from '@grandvisionhq/graphql';

const deleteShoppingListFragment = gql`
  fragment DeleteShoppingListFragment on ShoppinglistDeleteResult {
    success
  }
`;
var DELETE_SHOPPING_LIST = gql`
  mutation DeleteShoppingList($shoppinglistId: String!) {
    deleteShoppinglist(shoppinglistId: $shoppinglistId) {
      ...DeleteShoppingListFragment
    }
  }
  ${deleteShoppingListFragment}
`;

export { DELETE_SHOPPING_LIST as default };
//# sourceMappingURL=delete-shopping-list.js.map
